import React from "react";
import "./Contractdocumentation.css";
import logoimage from "../../assets/ايجار-1.png";
import Footer from "../Footer";

const Contractdocumentation = () => {
  return (
   <>
 <div className="head">
  <h3>يمكنك الحصول على عقدك الموثق من شبكة إيجار من أي مكان في المملكة</h3>
  <h2>طلب سكني | طلب تجاري</h2>
</div>

<img
  src={logoimage}
  alt="Real Estate Consulting"
  className="hero-image"
/>

<div className="contract-info">
  <h3>قصة عقود الإيجار طويلة الأجل</h3>
  <p>توثيق عقد الإيجار عبر المنصة الإلكترونية (منصة إيجار)</p>
  <p>مملوكة للهيئة العامة للعقار ومنصة إيجار</p>
  <p>معتمدة من الهيئة العامة للعقار</p>
  <p>تنفيذ العقود الموحدة للسكني والتجاري والزراعي</p>
  <p>للوثائق الإلكترونية</p>
  <p>الوقت مناسب</p>
  <p><strong>*إتمام العقود فورًا</strong></p>
</div>

      <Footer/>
      </>
     
        
       );
    };
    
    export default Contractdocumentation ;